import type { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import Flex from '@creditflowresearch/uilib/Flex';
import { MONTH_NAMES_SHORT, OverlayView } from './constants';
import MonthOverlay from './MonthOverlay';
import YearOverlay from './YearOverlay';
import useDatePickerNavigation from './useDatePickerNavigation';
import NavSection from './NavSection';

import styles from './datePickerHeader.module.scss';

interface IDatePickerHeaderProps extends ReactDatePickerCustomHeaderProps {
  minDate?: Date | null,
  maxDate?: Date | null,
}

const DatePickerHeader = ({
  date,
  changeMonth,
  changeYear,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  minDate,
  maxDate,
}: IDatePickerHeaderProps) => {
  const {
    overlayView,
    currentMonth,
    currentYear,
    toggleMonthOverlay,
    toggleYearOverlay,
    selectMonth,
    selectYear,
    decreaseYear,
    increaseYear,
  } = useDatePickerNavigation({ date, changeMonth, changeYear, minDate, maxDate });

  const showArrows = overlayView === OverlayView.None;

  return (
    <div className={ styles.headerWrapper } onMouseDown={ (e) => e.preventDefault() }>
      <Flex align="center" className={ styles.header }>
        <NavSection
          label={ MONTH_NAMES_SHORT[currentMonth] }
          isOpen={ overlayView === OverlayView.Month }
          showArrows={ showArrows }
          onLabelClick={ toggleMonthOverlay }
          onPrev={ decreaseMonth }
          onNext={ increaseMonth }
          prevDisabled={ prevMonthButtonDisabled }
          nextDisabled={ nextMonthButtonDisabled }
          dataTestPrev="datePickerHeaderPrevMonth"
          dataTestNext="datePickerHeaderNextMonth"
          dataTestLabel="datePickerHeaderMonth"
        />
        <div className={ styles.divider } />
        <NavSection
          label={ String(currentYear) }
          isOpen={ overlayView === OverlayView.Year }
          showArrows={ showArrows }
          onLabelClick={ toggleYearOverlay }
          onPrev={ decreaseYear }
          onNext={ increaseYear }
          prevDisabled={ prevYearButtonDisabled }
          nextDisabled={ nextYearButtonDisabled }
          dataTestPrev="datePickerHeaderPrevYear"
          dataTestNext="datePickerHeaderNextYear"
          dataTestLabel="datePickerHeaderYear"
        />
      </Flex>
      { overlayView === OverlayView.Month && (
        <MonthOverlay
          selectedMonth={ currentMonth }
          currentYear={ currentYear }
          minDate={ minDate }
          maxDate={ maxDate }
          onSelect={ selectMonth }
        />
      ) }
      { overlayView === OverlayView.Year && (
        <YearOverlay
          selectedYear={ currentYear }
          minDate={ minDate }
          maxDate={ maxDate }
          onSelect={ selectYear }
        />
      ) }
    </div>
  );
};

export default DatePickerHeader;
